export default "__VITE_ASSET__CLA5BW6p__"